import {
	type LayoutNavComponentProps,
	SvgFromUrl,
	TrackingLink,
} from '@ds-mgnl/marketing';
import { classNames } from '@dsx/react';
import logoSvg from '../../assets/images/ds-mxt-logo.svg';
import styles from './MxtLogo.module.css';

export type DsLogoProps = LayoutNavComponentProps;

export function MxtLogo({ transparent }: DsLogoProps) {
	return (
		<TrackingLink href="/" clickType="header_link" trackingText="Top Nav Logo">
			<SvgFromUrl
				url={logoSvg}
				height={'50px'}
				className={classNames(styles['mxt-logo'], {
					[styles['transparent']]: transparent,
				})}
			/>
		</TrackingLink>
	);
}
